import {Card, CardBody, CardHeader, Typography} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {ServiceSideCostPaymentGrid} from "./grid";
import {getServiceSideCostPayments} from "../../services/service/service_side_cost_payment";
import {CardFooterPaginator} from "../system/cardFooterPaginator";
import {ServiceSideCostPaymentContext} from "../../context/service_side_cost_payment";
import {PaginateContext} from "../../context/paginate";
import {ServiceSideCostPaymentForm} from "./form";


export function ServiceSideCostPaymentManagement() {

  const [serviceSideCostPayments, setServiceSideCostPayments] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [gridRowCount, setGridRowCount] = useState(10);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridSelectedRow, setGridSelectedRow] = useState(null);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);
  const [lastDataRefresh, setLastDataRefresh] = useState(null);

  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    if (gridTotalRowCount === 0) {
      setFrom(0)
    } else {
      setFrom((gridCurrentPage - 1) * gridRowCount + 1)
    }
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(paginate) {
    const result = await getServiceSideCostPayments(paginate);
    if (result.status === 200) {
      const {serviceSideCostSettlementList, total_count} = result.data;
      setServiceSideCostPayments(serviceSideCostSettlementList || []);
      setGridTotalRowCount(total_count);
    }
  }

  useEffect(() => {
    // const data = filter()
    const paginateParams = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
    })

    // const params = filter();
    // const filterParams = new URLSearchParams(params);
    //
    // for (const [key, value] of filterParams.entries()) {
    //   paginateParams.append(key, value);
    // }

    const paginate = paginateParams.toString()

    getData(paginate)
  }, [gridCurrentPage, gridRowCount, sortBy, sortType, lastDataRefresh]);

  return (
    <ServiceSideCostPaymentContext.Provider value={{
      serviceSideCostPayments: serviceSideCostPayments,
      setServiceSideCostPayments: setServiceSideCostPayments,
      serviceSideCostPayment: gridSelectedRow,
      setServiceSideCostPayment: setGridSelectedRow,
      open: modalOpen,
      setOpen: setModalOpen,
      setLastDataRefresh: setLastDataRefresh,
    }}>
      <PaginateContext.Provider value={{
        setSortBy: setSortBy,
        sortType: sortType,
        setSortType: setSortType,
        active: gridCurrentPage,
        setActive: setGridCurrentPage,
        totalRows: gridTotalRowCount,
        rowsCount: gridRowCount,
        setRowsCount: setGridRowCount,
        from: from,
        to: to,
      }}>
        <div className="">
          <ServiceSideCostPaymentForm/>
          <Card className="pt-8">
            <CardHeader floated={true} shadow={false} className="rounded-none">
              <div className="mb-8 flex items-center justify-between gap-8">
                <Typography variant="h5" color="blue-gray">تسویه هزینه های دولتی و جانبی</Typography>
              </div>
            </CardHeader>

            <CardBody className="overflow-x-auto w-full">
              <ServiceSideCostPaymentGrid/>
            </CardBody>

            <CardFooterPaginator/>

          </Card>
        </div>
      </PaginateContext.Provider>
    </ServiceSideCostPaymentContext.Provider>
  );
}